import { render, staticRenderFns } from "./TroskovnikReport.vue?vue&type=template&id=b2126d86"
import script from "./TroskovnikReport.vue?vue&type=script&lang=js"
export * from "./TroskovnikReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports